import { combineReducers } from "@reduxjs/toolkit";
import ArticleSlice from "@/components/ArticlePage/redux/slice";
import { ArticleState } from "@/components/ArticlePage/redux/types";
import categorySlice from "@/components/CategoryPage/redux/slice";
import { CategoryState } from "@/components/CategoryPage/redux/types";
import CollectionSlice from "@/components/CollectionsPage/redux/slice";
import { CollectionState } from "@/components/CollectionsPage/redux/types";
import ClusterSlice from "@/components/PageCluster/redux/slice";
import { ClusterState } from "@/components/PageCluster/redux/types";
import { LocationState } from "@/redux/slice/location/types/LocationState";
import { CartState } from "@/redux/slice/cart/types/CartState";
import LocationSlice from "@/redux/slice/location/slice";
import CartSlice from "@/redux/slice/cart/slice";
import { ProfileState } from "@/components/ProfileSideDrawer/redux/types";
import HomeSlice from "@/components/PageHome/redux/slice";
import { HomeState } from "@/components/PageHome/redux/types";
import PillarSlice from "@/components/PagePiller/redux/slice";
import { PillarState } from "@/components/PagePiller/redux/types";
import ProfileSlice from "@/components/ProfileSideDrawer/redux/slice";
import SavedCollectionsSlice from "@/components/SavedCollectionsListing/redux/slice";
import { SavedCollectionsState } from "@/components/SavedCollectionsListing/redux/types";
import VideoSlice from "@/components/VideoPage/redux/slice";
import { VideoState } from "@/components/VideoPage/redux/types";
import AuthSlice from "@/redux/slice/auth/slice";
import { AuthState } from "@/redux/slice/auth/types/AuthState";

import ToolsSlice from "@/components/ToolsPage/redux/slice";
import { ToolsState } from "@/components/ToolsPage/redux/types";
import ToolResultSlice from "@/components/ToolsResultPage/redux/slice";
import { ToolResultState } from "@/components/ToolsResultPage/redux/types";
import GlobalSlice from "@/redux/slice/global/slice";
import { GlobalState } from "@/redux/slice/global/types";

export type RootState = {
  auth: AuthState;
  home: HomeState;
  article: ArticleState;
  video: VideoState;
  category: CategoryState;
  pillar: PillarState;
  cluster: ClusterState;
  cart: CartState;
  location: LocationState;
  profile: ProfileState;
  collection: CollectionState;
  savedCollections: SavedCollectionsState;
  tool: ToolsState;
  toolResult: ToolResultState;
  global: GlobalState;
};

// Combine reducers
const rootReducers = combineReducers({
  auth: AuthSlice,
  home: HomeSlice,
  article: ArticleSlice,
  video: VideoSlice,
  category: categorySlice,
  pillar: PillarSlice,
  cluster: ClusterSlice,
  location: LocationSlice,
  cart: CartSlice,
  profile: ProfileSlice,
  collection: CollectionSlice,
  savedCollections: SavedCollectionsSlice,
  tool: ToolsSlice,
  toolResult: ToolResultSlice,
  global: GlobalSlice,
});

export default rootReducers;
